import { render } from "./Close.vue?vue&type=template&id=37a59786&scoped=true&ts=true"
import script from "./Close.vue?vue&type=script&lang=ts"
export * from "./Close.vue?vue&type=script&lang=ts"

import "./Close.vue?vue&type=style&index=0&id=37a59786&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a59786"]])

export default __exports__